import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Button, Menu, MenuItem } from '@material-ui/core'
import DuplicateExamModal from './DuplicateExamModal'
import axiosConfig from 'utils/axiosConfig'
import { v4 as uuid } from 'uuid'

export default function MenuButton(props) {
  const { exam, classrooms, refreshExams } = props
  const [anchorEl, setAnchorEl] = useState(null)
  const [duplicateModalState, setDuplicateModalState] = useState(false)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  }

  const openDuplicateExamModal = () => {
    setDuplicateModalState(uuid())
    handleClose()
    refreshExams()
  }

  const deleteExamination = () => {
    axiosConfig.post(`/examinations/${exam.id}/delete`)
      .then(response => console.log(response))

    handleClose()

    refreshExams()
  }

  return (
    <div>
      <Button onClick={handleClick} variant="contained" color="secondary" size="small" disableElevation>
         <i className="fa fa-caret-down"></i>
      </Button>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}

        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <MenuItem onClick={handleClose}>
          <Link to={`examinations/${exam.id}/submissions`}>
            <i className="fa fa-eye"></i> &nbsp; View Submissions
          </Link>
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <Link to={`/examinations/${exam.id}/edit`}>
            <i className="fa fa-edit"></i> &nbsp; Edit
          </Link>
        </MenuItem>
        <MenuItem onClick={openDuplicateExamModal}>
          <i className="fa fa-copy"></i> &nbsp; Duplicate
        </MenuItem>
        <MenuItem onClick={deleteExamination}>
          <i className="fa fa-trash"></i> &nbsp; Delete
        </MenuItem>
      </Menu>

      <DuplicateExamModal state={duplicateModalState} onClose={() => {
        setDuplicateModalState(false)
        refreshExams()
      }} exam={exam} classrooms={classrooms} />
    </div>
  );
}